import React, { useEffect, useState } from 'react';
import {  } from 'antd';
import { Trans, useTrans } from 'base/utils/i18n'
import styles from './index.module.less';
import cn from 'classnames';

type IProps = {
    className?: string
}

const ProductStatus: React.FC<IProps> = (props) => {
    const { className } = props;

    const { t } = useTrans()
    return(
        <div className={className}>
            <p className={cn(styles.text, 'g-text text-center')}>
                {t("web_shop_activity_early_access_applications_closed")}
            </p>
        </div>
    );
};

export default ProductStatus